export enum PaymentMethodEnum {
  BankTransfer = 1,
  Cash = 2,
  eWallet = 3,
  Card = 4,
  InternalTransfer = 5,
  Solana = 7,
}
